export default __webpack_public_path__ + "static/media/why.e2c53b7a.PNG";